/* tslint:disable */
/* eslint-disable */
/**
 * Solar Schools - Public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: dev@solarschools.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export * from "./api";
export * from "./configuration";



//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk-typescript/dist/index.js
// module id = DZUo
// module chunks = 22